import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

interface ScrollToTopOnRouteEnterOptions {
  scrollOnPop?: boolean
  enabled?: boolean
}

export function useScrollToTopOnRouteEnter(
  options: ScrollToTopOnRouteEnterOptions = {},
) {
  const location = useLocation()
  const navigationType = useNavigationType()
  const { scrollOnPop = false, enabled = true } = options

  useEffect(() => {
    if (!enabled) {
      return
    }

    if (!scrollOnPop && navigationType === 'POP') {
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [enabled, location.pathname, navigationType, scrollOnPop])
}
